<template>
  <div>
    <v-layout>
      <v-flex xs12 md3>
        <v-card shaped elevation="12" outlined class="mx-4 mt-2">
          <v-list-item three-line>
            <v-select
              prepend-inner-icon="search"
              class="mx-4"
              v-model="selectedFolder"
              :items="folders"
              solo-inverted
              flat
              hide-details
              label="Select Image Folder"
              @change="getImages()"
            ></v-select>
          </v-list-item>
        </v-card>
      </v-flex>

      <v-flex xs12 md8>
        <v-layout row wrap class="pl-10">
          <input
            type="file"
            ref="fileInput"
            style="display:none"
            accept="image/*"
            @change="getSelectedImage()"
          />
          <v-flex xs12 md3 class="mx-5 my-6">
            <v-card class="pa-0" elevation="24" v-if="selectedFolder" min-width="230">
              <v-img :src="selectedImage" height="150px"></v-img>

              <v-card-actions>
                <v-btn
                  outlined
                  dark
                  color="indigo"
                  v-if="selectedFolder"
                  @click="$refs.fileInput.click()"
                >Select Img</v-btn>
                <v-btn
                  class="mx-2 my-6"
                  outlined
                  dark
                  :color="getThemeColor"
                  v-if="selectedImage"
                  @click="uploadImage()"
                >Upload</v-btn>
              </v-card-actions>
            </v-card>
            <Loader></Loader>
          </v-flex>
          <v-flex
            v-for="(image,i) in images"
            :key="i+Math.random()+Math.random()"
            xs12
            md3
            class="mx-5 my-6"
          >
            <v-card class="pa-0" dark elevation="24" shaped>
              <v-img
                :src="$store.state.apiUrl+'/images/'+selectedFolder+'/'+getUserSchool.emis+'/'+image"
                height="200px"
              ></v-img>

              <v-card-actions>
                <v-btn
                  outlined
                  :style="{'color':getThemeColor}"
                  rounded
                  @click="replaceImg(image)"
                >Replace</v-btn>
                <v-btn outlined color="red" rounded @click="deleteImg(image)">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
export default {
  props: ["folders"],
  components: { Loader },
  updated() {
    this.imageToBeReplaced = null;
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },
  data() {
    return {
      selectedFolder: null,
      selectedImage: "https://api.baronitsolution.com/images/add_image.png",
      selectedImageName: null,
      images: [],
      imageToBeReplaced: null
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    replaceImg(image) {
      this.imageToBeReplaced = image;
      this.$refs.fileInput.click();
    },

    deleteImg(image) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-image",
          { image: image, folder: this.selectedFolder },
          this.getAccessToken
        )
        .then(images => {
          this.$store.commit("setLoader", false);
          this.images = images;
        });
    },
    getSelectedImage() {
      const file = event.target.files[0];
      this.selectedImageName = file.name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedImage = fileReader.result;
        if (this.imageToBeReplaced != null) {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/replace-image",
              {
                image64: fileReader.result,
                folder: this.selectedFolder,
                oldName: this.imageToBeReplaced,
                newName: this.selectedImageName
              },
              this.getAccessToken
            )
            .then(images => {
              this.$store.commit("setLoader", false);
              this.images = images;
            });
        }
      });
      fileReader.readAsDataURL(file);
    },
    uploadImage() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/upload-image",
          {
            image64: this.selectedImage,
            name: this.selectedImageName,
            folder: this.selectedFolder
          },
          this.getAccessToken
        )
        .then(images => {
          this.$store.commit("setLoader", false);
          this.images = images;
        });
    },
    getImages() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-images-for-given-folder",
          {
            folder: this.selectedFolder
          },
          this.getAccessToken
        )
        .then(images => {
          this.images = images;
          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>